import React from "react";
import {
  IonList,
  IonListHeader,
  IonLabel,
} from "@ionic/react";
import "../theme/AppStyles.css";
import { WORKFLOW_WERKER_TYPES } from "../functions/postActionTypes";


export const AllAssociatedJobsDocs: React.FC<any> = ({ detailsArray }: { detailsArray: any[] }) => {
    
  // console.log("AllAssociatedJobsDocs");

  // Helper function to determine job category for sorting
  const getJobCategory = (job: any) => {
    // const { jobStatusSched, jobStatusWerker } = job.jobInfo.status;
    // const dateTimeFinish = new Date(job.jobInfo.core.dateTimeFinish);
    // const now = new Date();
    
    // 1. Scheduler
    if (job.docStamp.userInfoFrom.uid === job.docStamp.userInfoTo.uid) {
      return 1;
    }
      
    // 2. Past werkers
    if (job.jobInfo.status.jobStatusWerker === WORKFLOW_WERKER_TYPES.Past) {
      return 2;
    }


    // 3. Scheduled werkers
    if (job.jobInfo.status.jobStatusWerker === WORKFLOW_WERKER_TYPES.Scheduled) {
      return 3;
    }
    
    
    // 4. Invited werkers
    if (job.jobInfo.status.jobStatusWerker === WORKFLOW_WERKER_TYPES.Invited) {
      return 4;
    }
      
    // 5. Expired werkers
    if (job.jobInfo.status.jobStatusWerker === WORKFLOW_WERKER_TYPES.Expired) {
      return 5;
    }
    
    // 6. Cancelled werkers
    if (job.jobInfo.status.jobStatusWerker === WORKFLOW_WERKER_TYPES.Cancelled) {
      return 6;
    }
      
    // return 7;
    return 0; // Placeholder

  };

  const getCategoryLabel = (category: number): string => {
    // console.log("category", category);
    const labels: { [key: number]: string } = {
      0: "Uncategorized",
      1: "Scheduler",
      2: "Past Werkers",
      3: "Scheduled Werkers",
      4: "Invited Werkers",
      5: "Expired Werkers",
      6: "Cancelled Werkers",
    };
    return labels[category] || "Unknown";
  };

  // Sort jobs and track category changes
  const sortedJobs = detailsArray.sort((a, b) => {
    const categoryA = getJobCategory(a);
    const categoryB = getJobCategory(b);
    
    if (categoryA !== categoryB) {
      return categoryA - categoryB;
    }
    
    const dateA = new Date(a.jobInfo.core.dateTimeStart).getTime();
    const dateB = new Date(b.jobInfo.core.dateTimeStart).getTime();
    
    return dateA - dateB;
  });

  // Track current category to insert headers
  let currentCategory: number | null = null;

  return (
    <React.Fragment>
      {sortedJobs.map((job, index) => {
        const jobCategory = getJobCategory(job);
        const showCategoryHeader = currentCategory !== jobCategory;
        
        // Update current category
        if (showCategoryHeader) {
          currentCategory = jobCategory;
        }

        return (
          <React.Fragment key={index}>
            {showCategoryHeader && (
              <IonListHeader 
                style={{
                  backgroundColor: '#f4f4f4',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  padding: '15px 10px',
                  marginTop: index > 0 ? '20px' : '0'
                }}              >
                <IonLabel>{getCategoryLabel(jobCategory)}</IonLabel>
              </IonListHeader>
            )}
            
            <IonList
            >
              <h2>Job #{index + 1}</h2>
              
              {/* Display structured data */}
              <div style={{ padding: '10px' }}>
              </div>

              {/* Raw JSON for debugging */}
              <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '10px' }}>
                {JSON.stringify(job, null, 2)}
              </pre>
            </IonList>
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};
